import React, { useEffect, useState } from 'react'
import classnames from 'classnames'
import { SmoothScrollFirstPage } from '../../Background/utils/SmoothScrollManager'
import { Iconfont } from '../../../components/Icon'
import './style.scss'

const Intro: React.FC = () => {
  const [active, setActive] = useState(false)

  useEffect(() => {
    const hd = setTimeout(() => {
      setActive(true)
    }, 1_000)

    return () => {
      clearTimeout(hd)
    }
  }, [])

  return (
    <SmoothScrollFirstPage>
      <div id="intro" className={classnames({ active })}>
        <div className="subtitle">Web3 Security Cornerstone and the New</div>
        <div className="subtitle">Contract Security Defense Paradigm</div>
        <div className="links">
          <Iconfont name="twitter" link="https://twitter.com/Sandbags_io" />
          <Iconfont name="medium" link="https://medium.com/@Sandbags_io" />
          <Iconfont name="github" link="https://github.com/sandbags-protocol" />
          <Iconfont name="document" link="https://docs.sandbags.io/" />
        </div>
        <div className="follow">
          <div className="bar"></div>
          <div className="bar"></div>
          <div className="bar"></div>
        </div>
      </div>
    </SmoothScrollFirstPage>
  )
}

export default Intro
